import {featureFlags} from '@cl/shared';
import {FeatureFlagKey} from '../featureFlags.types';

// relies on the current in-memory data regarding enabled flags
export default function isFlagEnabled(flag: FeatureFlagKey) {
  if (!featureFlags.enabledFlagsSubject.data) throw new Error('Feature flags not initialized');

  return featureFlags.enabledFlagsSubject.data.has(flag);
}
